import { useAppSelector } from '@Hooks/index';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { getAttendanceTypesDict } from '@Store/selectors/dictionarySelector';
import { MButton } from '@Components/Base';
import ESSFeatureRoutePath from '@Features/router/ess/ESSFeatureRoutePath.enum';
import { ColumnDataType } from '../list';
import styles from './own-action.module.css';

interface OwnActionProps {
  record?: ColumnDataType;
}

const OwnAction: React.FC = ({ record }: OwnActionProps) => {
  const navigate = useNavigate();
  const requestTypes = useAppSelector(getAttendanceTypesDict);
  if (!record) {
    return null;
  }

  const { createButton: isCreateButton, date } = record;

  const latePunchInfo = requestTypes.find(
    (type) => type.codeDesc === 'Late Punch'
  );

  const handleNavigateToCreateAttendance = (): void => {
    const goToPath = `/ess/${ESSFeatureRoutePath.MANAGE_REQUESTS}/${ESSFeatureRoutePath.MANAGE_REQUEST_ATTENDANCE_REQUEST}/${ESSFeatureRoutePath.MANAGE_REQUEST_CREATE_ATTENDANCE_REQUEST}`;

    navigate(goToPath, {
      state: { date, requestType: latePunchInfo?.codeNum },
    });
  };

  return (
    <MButton
      onClick={handleNavigateToCreateAttendance}
      className={styles.handleButton}
      disabled={!isCreateButton}
    >
      <PlusOutlined />
    </MButton>
  );
};

export default OwnAction;
